// reportingActions.js
import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';

export const FETCH_BALANCE_REPORTING_REQUEST = 'FETCH_BALANCE_REPORTING_REQUEST';
export const FETCH_BALANCE_REPORTING_SUCCESS = 'FETCH_BALANCE_REPORTING_SUCCESS';
export const FETCH_BALANCE_REPORTING_FAILURE = 'FETCH_BALANCE_REPORTING_FAILURE';
const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const getBalanceTransReportingData = (roleFilter = {}) => async (dispatch) => {
  dispatch({ type: FETCH_BALANCE_REPORTING_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'reporting',
      command: 'transactionReport',
      loggedInUserRole,
      loggedInUsername,
      roleFilter,
    });
    console.log('response', response.data.data);
    dispatch({
      type: FETCH_BALANCE_REPORTING_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_BALANCE_REPORTING_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch reporting data',
    });
  }
};
